export default __webpack_public_path__ + "static/media/acceleX.6964c8e2.svg";